import { render, staticRenderFns } from "./OnBoardingLoader.vue?vue&type=template&id=0439714b&scoped=true&"
import script from "./OnBoardingLoader.vue?vue&type=script&lang=js&"
export * from "./OnBoardingLoader.vue?vue&type=script&lang=js&"
import style0 from "./OnBoardingLoader.vue?vue&type=style&index=0&id=0439714b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0439714b",
  null
  
)

export default component.exports